var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row chartArea"},[_c('div',{staticClass:"col-xl-12 col-lg-6 innerBox",style:({ padding: '5px' })},[_c('div',{staticClass:"col-xl-12 mixChart"},[_c('scatter-chart',{ref:"chart",style:({ height: '100%', padding: '15px' }),attrs:{"chartData":_vm.scatterChartData.data,"options":_vm.scatterChartData.options}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }